'use client'

import { createContext } from 'react'

import { ConfigurationState } from '@marketplace-web/catalog/catalog-data'

import { initialConfigurationState } from '../CatalogProvider'

export type ContextType = ConfigurationState

const Context = createContext<ContextType>(initialConfigurationState)

export default Context
